import * as React from 'react'

import { dimensions } from '@factorialco/deprecated-design-system'
import once from 'lodash/once'

import TetherComponent from 'modules/core/components/TetherComponent'

type Props<Value> = {
  children: React.ReactNode
  value?: Value
  onValueChange: (value: Value) => void
  closeOnChange?: boolean
  defaultOpen: boolean
  onClose?: () => void
  open?: boolean
  setOpen?: (open: boolean) => void
}

type Context<Value> = {
  value?: Value
  open: boolean
  setOpen: (open: boolean) => void
  onValueChange: (value: Value) => void
}

export const createContext = once(function <Value>() {
  return React.createContext<Context<Value> | null>(null)
})

function Base<Value>({
  children,
  value,
  onValueChange: onValueChangeProp,
  closeOnChange = true,
  defaultOpen,
  onClose,
  open: externalOpen,
  setOpen: externalSetOpen,
}: Props<Value>) {
  const Context = createContext<Value>()

  const [internalOpen, internalSetOpen] = React.useState(defaultOpen)
  const isOpen = externalOpen !== undefined ? externalOpen : internalOpen
  const setOpen = externalSetOpen || internalSetOpen

  const onValueChange = (value: Value) => {
    if (closeOnChange) {
      setOpen(false)
      onClose?.()
    }
    onValueChangeProp(value)
  }

  const contextValue = {
    value,
    open: isOpen,
    setOpen,
    onValueChange,
  }

  return (
    <Context.Provider value={contextValue}>
      <TetherComponent attachment="top center" offset={`-${dimensions.s8} 0`}>
        {children}
      </TetherComponent>
    </Context.Provider>
  )
}

export default Base
